import type { Nullable } from "@core/domain/types/nullable.type.ts";
import type { StringKeyof } from "@core/domain/types/string-keyof.type.ts";
import type { Undefinable } from "@core/domain/types/undefinable.type.ts";

export enum OrderDirectionEnumDto {
    Asc = "asc",
    Desc = "desc",
}

/**
 * This map is used to map the fields of the model to the fields of the DTO
 * If the value is null, it means that the field is not sortable
 */
export type OrderByMapDto<Model extends object, Dto extends object> = Record<
    StringKeyof<Model>,
    Nullable<StringKeyof<Dto>>
>;

/**
 * This type is used to define the order query
 * @example "id asc"
 */
export type OrderByDto<Dto extends object> =
    Undefinable<`${StringKeyof<Dto>} ${OrderDirectionEnumDto}`>;
